<div class="modal-header">
  <h4 class="modal-title pull-left">{{ modal.title }}</h4>
  <!-- <button
    type="button"
    class="close pull-right"
    aria-label="Close"
    *ngIf="!modal.avoidClose"
    (click)="bsModalRef.hide()"
  >
    <span aria-hidden="true">&times;</span>
  </button> -->

  <img
    src="/assets/icons/modal-close.svg"
    height="40px"
    class="pull-right clickable"
    aria-label="Close"
    *ngIf="!modal.avoidClose"
    (click)="bsModalRef.hide()"
  />
</div>
<div class="modal-body">
  <div [innerHTML]="modal.mainText" class="text-center"></div>
  <hr />
  <div [ngSwitch]="type">
    <div *ngSwitchCase="'job-offer'">
      <app-job-offer-feedback
        (onError)="modal.onError(); modal.avoidClose = false"
        (onSucces)="modal.onSuccess()"
      ></app-job-offer-feedback>
    </div>
    <div *ngSwitchDefault>
      <h1>No setup config found for feedback.</h1>
    </div>
  </div>
  <div class="modal-footer" *ngIf="modal.showFooter">
    <button type="button" class="btn btn-default" (click)="bsModalRef.hide()">
      {{ closeLabel }}
    </button>
  </div>
</div>
